import React from "react";
import Lottie from 'react-lottie-player';
import loadingAnimation from './lotties/magnifying-glass.json';


const AnimatedLoader = ({ width = 500, height = 500 }) => (
  <Lottie
      loop
      animationData={loadingAnimation}
      play
      style={{ width, height, textAlign: 'center', margin: '0 auto'}}
    />
);

export default AnimatedLoader;
